var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldHighRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shield-high-risk",
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.693,
    height: 81.897,
    viewBox: "0 0 71.693 81.897",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2391",
    "data-name": "Group 2391"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shield-fill-exclamation",
    d: "M36.846,0c-3.533,0-9.438,1.356-14.994,2.866C16.168,4.4,10.438,6.219,7.068,7.32a7.883,7.883,0,0,0-5.346,6.46c-3.052,22.916,4.03,39.9,12.623,51.134A60.3,60.3,0,0,0,27.234,77.469a36.3,36.3,0,0,0,5.367,3.2A10.865,10.865,0,0,0,36.846,81.9a10.89,10.89,0,0,0,4.245-1.228,36.665,36.665,0,0,0,5.367-3.2A60.287,60.287,0,0,0,59.347,64.914C67.94,53.678,75.022,36.695,71.97,13.779a7.889,7.889,0,0,0-5.346-6.465Q59.287,4.91,51.84,2.861C46.284,1.362,40.38,0,36.846,0ZM34.03,43.518,32.237,25.567a4.634,4.634,0,1,1,9.218,0L39.663,43.518a2.827,2.827,0,0,1-5.633,0Zm2.827,17.9A5.119,5.119,0,1,1,41.977,56.3,5.12,5.12,0,0,1,36.856,61.423Z",
    transform: "translate(-1)",
    fill: "#ed2926",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldHighRisk);
export default __webpack_public_path__ + "static/media/shield-high-risk.c0af712529fd426b3a8488de12b7e548.svg";
export { ForwardRef as ReactComponent };